import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import jwt_decode from "jwt-decode";
import axios from "axios";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from "../apiConfig";


const BlFromAdminReport = () => {
  // Token
  const token = localStorage.getItem("jwtToken");
  const decodedToken = jwt_decode(token);
  const user_id = decodedToken.user_id;

  // State
  const [data, setData] = useState([]);
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const currentPage = useRef(1);
  //setting state paginate
  const [agentdata, setAgentData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0); 

  useEffect(() => {
    getPaginatedUsers();
  }, []);

 
  const getPaginatedUsers = async () => {
    try {
        const response = await axios.get(`${apiConfig.baseURL}/api/agent/BlFromSuperAdmin/${user_id}`, {
            params: {
              page: currentPage.current,
              limit: limit,
            }
        });   

        const newData  = response.data.data;
        // console.log(newData);
        setAgentData(newData);        
        setIsLoading(false);

        const total = newData.reduce((acc, item) => acc + item.amount, 0);
        setTotalAmount(total);

    } catch (error) {
        setError(error.message);
        setIsLoading(false);
    }
  };

  // Pagination handling
  const handlePageClick = (e) => {
    currentPage.current = e.selected + 1;
    getPaginatedUsers();
  };

  const changeLimit = () => {
    currentPage.current = 1;
    getPaginatedUsers();
  };


  const formatTimestamp = (timestamp) => {
    let date;
    if (timestamp !== undefined && timestamp !== null) {
        date = new Date(timestamp);
    } else {
        date = new Date(); // Use current time if timestamp is undefined or null
    }

    const formattedTime = date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit'
    }).toLowerCase();

    const formattedDate = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
    }).replace(/\//g, '.');

    return `${formattedTime} ${formattedDate}`;
};

  // CSS for pagination
  const MyPaginate = styled(ReactPaginate).attrs({
    activeClassName: "active",
  })`
    margin-bottom: 2rem;
    display: flex;
    justify-content: center;
    list-style: none;
    padding: 0;

    li a {
      border-radius: 5px;
      padding: 0.5rem 1rem;
      border: 1px solid gray;
      margin: 0 5px;
      cursor: pointer;
    }

    li.active a {
      background-color: #007bff;
      color: white;
      border: none;
    }

    li.disabled a {
      color: #ccc;
      cursor: not-allowed;
    }
  `;


  
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
    };

    const timeString = date.toLocaleString('en-US', options);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);

    return `${timeString.toLowerCase()} ${day}.${month}.${year}`;
};


  return (
    <div id="main-wrapper">
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />
      
      <div className="content-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Balance Received Report</h4>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {agentdata.length > 0 ? (
                      agentdata.map((item, index) => (
                        <tr key={index}>
                          <td>{item.sender_id}</td>
                          <td>{item.amount}</td>
                          <td>{item.s_key}</td>
                          <td>{formatDate(item.createdAt)}</td> 
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
               
                <p> Total Amount : {totalAmount} TK</p>
              
                <MyPaginate
                  breakLabel="..."
                  nextLabel="Next >"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={5}
                  pageCount={pageCount}
                  previousLabel="< Previous"
                  forcePage={currentPage.current - 1}
                />
            
            
            {/* <div className="mt-3">
                  <select
                    value={limit}
                    onChange={(e) => {
                      setLimit(e.target.value);
                      changeLimit();
                    }}
                    className="form-select"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                  </select>
                </div> */}


              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BlFromAdminReport;
